  import React from "react";
import { Tabs } from 'antd';
import PureChemicalStockList from "../components/chemical/PureChemicalStockList";
import PureChemicalConfigList from "../components/chemical/PureChemicalConfigList";
import SellChemicalList from "../components/setting-conponents/Seller/SellChemicalList";

export default function PureChemicalView() {

  const items = [
    {
      key: 'stock',
      label: 'สต๊อกเคมีภัณฑ์',
      children: <PureChemicalStockList />,
    },
    {
      key: 'setting',
      label: 'ตั้งค่าชื่อเคมีภัณฑ์',
      children: <PureChemicalConfigList />,
    },
    {
      key: "chemical",
      label: "ผู้ขายสารเคมี",
      children: <SellChemicalList isDone={false}/>,
    },
  ];

  return (
    <div>
      <Tabs 
        destroyInactiveTabPane
        defaultActiveKey="quality" 
        items={items}
        style={{ marginTop : 15}}
      />

    </div>
  )
}